/** 
 * @module Export all locale translations
 */

let locales = {};
locales['en-UK'] = require('./en-UK.json');
locales['da-DK'] = require('./da-DK.json');

export default locales;
